import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SoakingDTO } from 'business/models/Models';

const initialState = Array<SoakingDTO>();
const SoakingSlice = createSlice({
  name: 'soakings',
  initialState,
  reducers: {
    setAllSoakings: (state, action: PayloadAction<SoakingDTO[]>) => {
      return action.payload;
    },
    updateSoakings: (state, action: PayloadAction<SoakingDTO[]>) => {
      const updatedSoakings = state;
      action.payload.forEach((item) => {
        const index = state.findIndex((obj) => obj.id === item.id);
        if (index == -1) {
          updatedSoakings.push(item);
        } else {
          updatedSoakings[index] = { ...state[index], ...item };
        }
      });
      return updatedSoakings;
    },
    deleteSoakings: (state, action: PayloadAction<SoakingDTO[]>) => {
      const soakingListAfterDeletion = state.filter(
        (i) => !action.payload.find((f) => f.id === i.id),
      );
      return soakingListAfterDeletion;
    },
  },
});

export const { setAllSoakings, updateSoakings, deleteSoakings } = SoakingSlice.actions;

export default SoakingSlice.reducer;
